export enum OffscreenApiE {
    GET_DEVICES = 'OFFSCREEN/GET_DEVICES',
    START_REC = 'OFFSCREEN/START_REC',
    STOP_REC = 'OFFSCREEN/STOP_REC',
    CANCEL_REC = 'OFFSCREEN/CANCEL_REC',
    GET_REC_START_TIME = 'OFFSCREEN/GET_REC_START_TIME',
    WINDOW_CONFIRM = 'OFFSCREEN/WINDOW_CONFIRM',
    UPLOAD_REC = 'OFFSCREEN/UPLOAD_REC',
}

export type OffscreenMsg = {
    action: `${OffscreenApiE}`
    params?: any
}
